var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLine(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.71345 7.35853C10.1959 7.35853 11.3976 6.1568 11.3976 4.67438C11.3976 3.19197 10.1959 1.99023 8.71345 1.99023C7.23103 1.99023 6.0293 3.19197 6.0293 4.67438C6.0293 6.1568 7.23103 7.35853 8.71345 7.35853Z",
    stroke: "#686978",
    strokeWidth: 2.89888
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.7628 23.4629H6.69726C4.01311 23.4629 2 21.5055 2 18.7656C2 16.0258 4.01311 14.0684 6.69726 14.0684H11.3945H21.4601C24.1442 14.0684 26.1573 12.1109 26.1573 9.37109C26.1573 6.63124 24.1442 4.67383 21.4601 4.67383H11.3945M2 4.67383H6.02622M22.1311 23.4629H26.1573",
    stroke: "#686978",
    strokeWidth: 2.89888,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.4459 26.1495C20.9283 26.1495 22.13 24.9478 22.13 23.4654C22.13 21.983 20.9283 20.7812 19.4459 20.7812C17.9635 20.7812 16.7617 21.983 16.7617 23.4654C16.7617 24.9478 17.9635 26.1495 19.4459 26.1495Z",
    stroke: "#686978",
    strokeWidth: 2.89888
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLine);
export default __webpack_public_path__ + "static/media/line.f3054131ddaabd06a2a3475cb8d98601.svg";
export { ForwardRef as ReactComponent };